export const initialState = {
  status: 'Waiting',
  color: '#8e33f0',
};

const modalReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'Success':
      return {
        ...state,
        status: 'Success',
        color: '#9ccc65',
      };

    case 'Confirmed':
      return {
        ...state,
        status: 'Confirmed',
        color: '#ffba57',
      };
    case 'Engaged':
      return {
        ...state,
        status: 'Engaged',
        color: '#4680ff',
      };
    case 'Completed':
      return {
        ...state,
        status: 'Completed',
        color: '#68f3f8',
      };

    default:
      return state;
  }
};

export default modalReducer;
